<app-service-alert-banner></app-service-alert-banner>

@if (bewpBanner) {
  <app-notification-banner-container
    [cid]="cid"
    [banner]="bewpBanner"
    (updateOptIn)="acceptOptIn($event)"
    (ignorePaperlessEnrollmentBanner)="dismissPaperlessBanner()"
  ></app-notification-banner-container>
} @else {
  @for (notification of notifications; track notification; let i = $index) {
    <div
      class="notification-banner"
      [ngClass]="notification?.class || 'notification-banner--error'"
      #wrapperEl
      >
      <div class="notification-banner__inner">
        <!-- Icon -->
        @if (notification?.icon) {
          <div class="notification-banner__icon">
            @switch (notification.icon.type) {
              @case ('bell') {
                <app-icon-bell
                  width="24"
                  height="24"
                  [color]="notification.icon.color"
                  >
                </app-icon-bell>
              }
              @case ('check') {
                <app-icon-check-badge
                  width="20"
                  height="20"
                  [color]="notification.icon.color"
                  >
                </app-icon-check-badge>
              }
            }
          </div>
        }
        <!-- Notification Content -->
        <div
          class="notification-banner__content"
          >
          @switch (notification.type) {
            <!-- loan past due -->
            @case ('loanPastDue') {
              <p class="notification-banner__text">
                @if (pastDueLoanAccount.autoPayStatus === 'Enrolled') {
                  You have a past-due payment. Please pay your past due amount of
                  <span class="font-medium">{{
                    pastDueLoanAccount?.pastDueAmount
                    | currency : 'USD' : 'symbol' : '1.2-2'
                    }}</span
                    >.
                  }
                  @if (pastDueLoanAccount?.autoPayStatus !== 'Enrolled') {
                    You have a past-due payment. Please pay your past due amount of
                    <span class="font-medium">{{
                      pastDueLoanAccount?.pastDueAmount
                      | currency : 'USD' : 'symbol' : '1.2-2'
                    }}</span>
                    to bring your account up to date. If you’d like to include your
                    upcoming payment of
                    {{
                    pastDueLoanAccount.nextPaymentAmountDue
                    | currency : 'USD' : 'symbol' : '1.2-2'
                    }}
                    due {{ pastDueLoanAccount?.nextDueDate | date : 'MM/dd' }}, you
                    can pay
                    {{
                    pastDueLoanAccount?.calculatedTotalAmountDue
                    | currency : 'USD' : 'symbol' : '1.2-2'
                    }}.
                  }
                </p>
                <a
                  id="loanLink"
                  data-test-id="customer-hub-past-due-make-payment-link"
                  class="be-body-s-bold"
                  (click)="triggerMakePaymentEev()"
              [href]="
                notification?.link +
                '&destination=makepayment&id=' +
                pastDueLoanAccount.id
              "
                  >
                  Make a payment now
                </a>
              }
              <!-- card past due -->
              @case ('cardPastDue') {
                <p class="notification-banner__text">
                  Your card account is past due. Click here to
                  <a
                    id="cardLink"
                    class="be-body-s-bold"
                    href="javascript:void(0)"
                    (click)="onCardPastDueNotificationClick()"
                    >
                    see your payment options.
                  </a>
                </p>
              }
              <!-- new limits -->
              @case ('newLimits') {
                <p class="notification-banner__text">
                  New limits! Get up to $100k for your bigger financial goals.
                  <a
                    id="newLimitsLink"
                    class="be-body-s-bold"
                    [routerLink]="notification.link"
                    (click)="onNewLimitsClick()"
                    >
                    View offers
                  </a>
                </p>
              }
              @case ('optIn') {
                <p class="notification-banner__text">
                  Your card account is past due. Click here to
                  <a
                    id="cardLink"
                    class="be-body-s-bold"
                    [routerLink]="notification.link"
                    (click)="onCardPastDueNotificationClick()"
                    >
                    see your payment options.
                  </a>
                </p>
              }
              @case ('paperlessEnrollment') {
                <p class="notification-banner__text">
                  Enroll in paperless statements.
                </p>
                <a
                  id="paperLessEnrollmentLink"
                  class="be-body-s-bold"
                  [routerLink]="notification.link"
                  (click)="onCardPastDueNotificationClick()"
                  >
                  Enroll now
                </a>
              }
              <!-- income capture -->
              @case ('incomeCapture') {
                <p class="notification-banner__text">Time to update your income.</p>
                <a
                  id="incomeCaptureNotification"
                  class="be-body-s-bold"
                  [routerLink]="notification.link"
                  [eevTrackClick]="notification.eevTrackClickEvent"
                  >
                  Update now
                </a>
              }
              <!-- residenceCapture -->
              @case ('residenceCapture') {
                <p class="notification-banner__text">
                  Time to update your residence information.
                </p>
                <a
                  id="incomeCaptureNotification"
                  class="be-body-s-bold"
                  [routerLink]="notification.link"
                  [eevTrackClick]="notification.eevTrackClickEvent"
                  >
                  Update now
                </a>
              }
              <!-- multiple profile updates -->
              @case ('multi-refresh') {
                <p class="notification-banner__text">
                  Time to update your information.
                </p>
                <a
                  id="incomeCaptureNotification"
                  class="be-body-s-bold"
                  [routerLink]="notification.link"
                  [eevTrackClick]="notification.eevTrackClickEvent"
                  >
                  Update now
                </a>
              }
              <!-- application boarded -->
              @case ('applicationBoarded') {
                <p class="notification-banner__text">
                  Your loan is funded! Congratulations on taking another step
                  towards your brighter financial future.
                </p>
              }
              <!-- application approved -->
              @case ('applicationApproved') {
                <p class="notification-banner__text">
                  Great news - your money should arrive in 1-3 days!
                  <a
                    [href]="notification?.link"
                    target="_blank"
                    class="be-body-s-bold"
                    (click)="fireApplicationClickEvent(notification?.clickEvent)"
                    >Click here</a
                    >
                    to check your Loan Status for updates.
                  </p>
                }
                <!-- application declined -->
                @case ('applicationDeclined') {
                  <p class="notification-banner__text">
                    We're sorry. We couldn't approve you for a loan at this time.
                    <a
                      [href]="notification?.link"
                      target="_blank"
                      class="be-body-s-bold"
                      (click)="fireApplicationClickEvent(notification?.clickEvent)"
                      >
                      Click here
                    </a>
                    to check your Loan Status for updates.
                  </p>
                }
                <!-- application error -->
                @case ('applicationError') {
                  <p class="notification-banner__text">
                    Something went wrong. Please retry the request or contact customer
                    support 855-282-6353 for assistance.
                  </p>
                }
              }
            </div>
            <!-- close button -->
            <div class="notification-banner__close">
              <button (click)="closeNotification($event, i)" class="btn-nude">
                <app-icon-close
                  color="#36445e"
                  width="20"
                  height="20"
                ></app-icon-close>
              </button>
            </div>
          </div>
        </div>
      }
    }

